var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "content"
  }, [_vm.$store.state.utils.configuration.enableNewNoWebglModal ? _c('div', [_c('div', {
    staticClass: "new-modal-error-icon"
  }, [_vm._v("!")]), _c('h2', {
    staticClass: "new-modal-title"
  }, [_vm._v(_vm._s(_vm.translations.oldBrowserHeader))]), _c('p', {
    staticClass: "new-modal-description"
  }, [_vm._v("\n      " + _vm._s(_vm.translations.oldBrowserDescription) + "\n    ")])]) : _c('h5', {
    staticClass: "text-center subheader"
  }, [_vm._v("\n    " + _vm._s(_vm.translations.noWebglSubHeader1)), _c('br'), _vm._v("\n    " + _vm._s(_vm.translations.noWebglSubHeader2) + "\n    " + _vm._s(_vm.translations.noWebglSubHeader3)), _c('br')])]);
}
var staticRenderFns = []

export { render, staticRenderFns }